import { Component, OnInit } from '@angular/core';
import { Apiservice } from '../../../services/ApiService';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { PermissionsService } from '../../../services/Permissions';



@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss','../styles/shared.scss' ]
})


export class UserManagementComponent implements OnInit {

  allUsers: any = [];
  venues: any[] = [];
  filteredUsers: any = [];
  primaryVenue: string = '';
  filterEmail: string = '';
  filterPrimaryVenue: string = '';
  userID: string = '';
  loading: boolean = false;
  filterVenue: string = '';



  constructor(private router: Router,private _http:HttpClient, private apiservice: Apiservice, private permissions: PermissionsService) {
   }

  ngOnInit(): void {
    this.loading = false;
    this.permissions.checkPermissions();
    this.getAllUsers();
  }


  getAllUsers() {
    this.loading = true;
    this.apiservice
      .getAllUsers()
      .subscribe((result: any) => {
        this.allUsers = result;
        this.filteredUsers = result
        this.loading = false;
      });

      
  }

  disableUser(event:any, user: { key: string; }){
    this.userID = user.key
    this.loading = true;
    const body ={}
   this._http.post('https://57hb9ue4x9.execute-api.ap-southeast-2.amazonaws.com/prod/userStatus?user=' + this.userID + '&enabled=false ', body).subscribe({
     next: data => {
     },
   
     error: error => {
      this.loading = false; 
      window.location.reload();
     },
     complete: () => {
      this.loading = false;
      window.location.reload();
    }
   })     
   }

   editUser(user : { email: string, venueAdmin: boolean, primaryVenueText: string, primaryVenue: string, venues: {} }){
    this.router.navigate(['users/edit'], { state: { email: user.email, venueAdmin: user.venueAdmin, primaryVenueText: user.primaryVenueText, primaryVenue:user.primaryVenue, venues: user.venues } });
   }

   enableUser(event:any, user: { key: string; }){
    this.userID = user.key
    this.loading = true;
    const body ={}
   this._http.post('https://57hb9ue4x9.execute-api.ap-southeast-2.amazonaws.com/prod/userStatus?user=' + this.userID + '&enabled=true ', body).subscribe({
     next: data => {
     },
   
     error: error => {
      this.loading = false;
      window.location.reload();
     },
     complete: () => {
      this.loading = false;
      window.location.reload();
    }
   })      
   }

   filterUsers() {
    console.log("Filtering Users...");
  
    this.filteredUsers = this.allUsers.filter((user: { email: string; primaryVenueText: string; venueList: {}[]; }) => {
      console.log("User before filter:", user);
      return (
        (!this.filterEmail || (user.email?.toLowerCase().includes(this.filterEmail.toLowerCase()))) &&
        (!this.filterPrimaryVenue || (user.primaryVenueText?.toLowerCase().includes(this.filterPrimaryVenue.toLowerCase()))) &&
        (!this.filterVenue.length ||
          (Array.isArray(user.venueList) &&
            user.venueList.some((venue: {}) => {
              const venueName = Object.keys(venue)[0]; 
              return venueName?.toLowerCase().includes(this.filterVenue.toLowerCase());
            })))
      );
    });
  
    console.log("Filtered Users:", this.filteredUsers);
  }
  
}